export default{
    userIdentity: {
        index: 'user-identity-index',
    }
}
